import { render, staticRenderFns } from "./MySidebarNavLink.vue?vue&type=template&id=1ca95245&"
import script from "./MySidebarNavLink.vue?vue&type=script&lang=js&"
export * from "./MySidebarNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports